import axios from 'axios';

const defaultBaseURL = process.env.NODE_ENV === 'development'
  ? '/api'
  : 'https://vprie-server-92dde99da64a.herokuapp.com/api';

const baseURL = (process.env.VUE_APP_API_BASE_URL || defaultBaseURL).replace(/\/+$/, '');

function resolveAssetOrigin() {
  const explicitOrigin = (process.env.VUE_APP_ASSET_ORIGIN || '').trim().replace(/\/+$/, '');
  if (explicitOrigin) return explicitOrigin;

  const normalizedApiBase = (process.env.VUE_APP_API_BASE_URL || defaultBaseURL).trim();
  if (/^https?:\/\//i.test(normalizedApiBase)) {
    return normalizedApiBase.replace(/\/api\/?$/i, '').replace(/\/+$/, '');
  }

  return process.env.NODE_ENV === 'development' ? 'https://vprie-server-92dde99da64a.herokuapp.com/' : '';
}

const assetOrigin = resolveAssetOrigin();

const api = axios.create({
  baseURL,
  timeout: 20000,
});

export function assetUrl(pathValue) {
  if (!pathValue) return '';
  if (/^(https?:)?\/\//i.test(pathValue) || /^data:|^blob:/i.test(pathValue)) return pathValue;

  const normalizedPath = pathValue.startsWith('/') ? pathValue : `/${pathValue}`;
  return assetOrigin ? `${assetOrigin}${normalizedPath}` : normalizedPath;
}

export default api;
